import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  wrapper: {
    position: 'relative',
  },
  error: {
    position: 'absolute',
    color: '#ED1C24',
  },
}));
